import { useTranslation } from "react-i18next";

/** Countries employees and customers of companies in Egypt and the Gulf come from, most often. */
const CODES = ["EG", "SA", "AE", "KW", "QA", "BH", "OM", "JO", "LB", "SY", "IQ", "PS", "YE", "SD", "LY", "TN", "DZ", "MA", "SO", "IN", "PK", "BD", "LK",
  "NP", "PH", "ID", "AF", "ET", "ER", "KE", "UG", "NG", "TR", "IR", "GB", "US", "CA", "FR", "DE", "IT", "ES", "CN", "KR", "MY", "TH", "RU", "UA", "AU"];

/** A country by its name in the user's language (the value stays its ISO code). */
export function CountrySelect({ value, onChange, invalid, first }: { value: string; onChange: (code: string) => void; invalid?: boolean; first?: string }) {
  const { t, i18n } = useTranslation();
  const names = new Intl.DisplayNames([i18n.language], { type: "region" });
  const all = [...new Set([...CODES, ...(value ? [value] : [])])].map((c) => ({ code: c, name: names.of(c) ?? c }))
    .sort((a, b) => (a.code === first ? -1 : b.code === first ? 1 : a.name.localeCompare(b.name, i18n.language)));
  return (
    <select className={invalid ? "field border-danger" : "field"} value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="">{t("common.select")}</option>
      {all.map((c) => <option key={c.code} value={c.code}>{c.name}</option>)}
    </select>
  );
}
